// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"career-path_wrapper___15wC","header":"career-path_header__p70J7","card-wrapper":"career-path_card-wrapper__qi9aS","loading":"career-path_loading__ASRbK"};